import { render, staticRenderFns } from "./KioskJoinForm.vue?vue&type=template&id=15e5ba41&scoped=true&"
import script from "./KioskJoinForm.vue?vue&type=script&lang=js&"
export * from "./KioskJoinForm.vue?vue&type=script&lang=js&"
import style0 from "./KioskJoinForm.vue?vue&type=style&index=0&id=15e5ba41&prod&lang=scss&scoped=true&"
import style1 from "./KioskJoinForm.vue?vue&type=style&index=1&id=15e5ba41&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5ba41",
  null
  
)

export default component.exports